import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/core';
import { CatlougeTypeConstants } from 'src/app/core/constants';
import { AssetsService } from 'src/app/core/services/assets.service';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { of } from 'rxjs';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from "src/app/core/services/common.service";

declare var $;

@Component({
  selector: 'app-favourite',
  templateUrl: './favourite.component.html',
  styleUrls: ['./favourite.component.css']
})
export class FavouriteComponent implements OnInit {
  userInfo: any;
  all_list:any = [];

  fav_list:any= []; 
  edit_fav_list:any= []; // for modal
  edit_category_id:any;
  fav_list2:any = []; // for listing
 assetImgParam  =  {"crop":'scale','width':80,'height':80};
notFoundImg = 'square';
 added_guruji:any = [];
 removed_guruji:any = [];
 reordered_guruji:any = [];
 category_id:any;
 category_name:any;
 todo = ['Get to work', 'Pick up groceries', 'Go home', 'Fall asleep'];

 done = ['Get up', 'Brush teeth', 'Take a shower', 'Check e-mail', 'Walk dog'];

 isCloudFrontType: boolean = true;


 drop(event: CdkDragDrop<string[]>) {
   if (event.previousContainer === event.container) {
     moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
   } else {

     transferArrayItem(
       event.previousContainer.data,
       event.container.data,
       event.previousIndex,
       event.currentIndex,
     );
   }
 }
  constructor(public activatedRoute: ActivatedRoute, public userService: UserService, 
              public assetsService: AssetsService,private spinner: NgxSpinnerService,  
              private modalService: NgbModal, public commonService: CommonService) {
               this.category_id =  this.activatedRoute.snapshot.queryParams.id;
              //  alert(this.category_id);
               }

  ngOnInit(): void {
    if(this.commonService.filterType ==1){
      this.isCloudFrontType = true ;
    }else{
      this.isCloudFrontType = false;
    }
    let slug =   localStorage.getItem('continuewatching');
    // localStorage.setItem('slugName', slug);
    // localStorage.setItem('slug', slug);
   this.getAllGuruji();


  }
  getAllGuruji() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let tabDataParams = {
      "catlogue": CatlougeTypeConstants.catlogue,
      "call": "getallfavourite",
    };
    let TabsDataParams = this.userService.convertoJSONToUrlEncoded(tabDataParams);
    this.assetsService.getAllGuruJiList(TabsDataParams).subscribe(data => {
      this.all_list = data.result;
      console.log('this.all_list',this.all_list[0].category_tab);
      
      data.result.forEach(element => {
        if(element.category_id == this.category_id) {
          this.category_name = element.category_name
        }
      });

      // data.result.forEach(element => {
      //   if(element.sub_categories && element.sub_categories.length) {
      //     element.sub_categories.forEach(item => {
      //       if(item.landing_page == '__tab') {
      //         this.all_list.push(item);
      //       }
      //     });
          
      //   }
      // });
      this.getFavList();


    });
  }

  // getAllGuruji2() {
  //   this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  //   let tabDataParams = {
  //     "catlogue": CatlougeTypeConstants.catlogue,
  //     "slug": this.userService.getCurrentSlugName,
  //     "call": "index",
  //     "page": 1,
  //     "limit": 50
  //   };
  //   let TabsDataParams = this.userService.convertoJSONToUrlEncoded(tabDataParams);
  //   this.assetsService.getHomePageTabData(TabsDataParams).subscribe(data => {
  //     this.all_list = [];

  //     data.result.forEach(element => {
  //       if(element.sub_categories && element.sub_categories.length) {
  //         element.sub_categories.forEach(item => {
  //           if(item.landing_page == '__tab') {
  //             this.all_list.push(item);
  //           }
  //         });
          
  //       }
  //     });
  //     this.getFavList();


  //   });
  // }
  getFavList() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let tabDataParams = {
      "catlogue": CatlougeTypeConstants.catlogue,
      "call": "getfavourite",
    };
    let TabsDataParams = this.userService.convertoJSONToUrlEncoded(tabDataParams);
    this.assetsService.getFavGuruJiList(TabsDataParams).subscribe(data => {
      // this.fav_list = data.result;
      // this.fav_list2 = data.result;
      this.fav_list = []
      data.result.forEach(element => {
        if(element._id == this.category_id) {
          this.fav_list.push(element)
        }
      });
        /** spinner ends */
        this.spinner.hide();
      this.fav_list2 =  this.fav_list.map((_arrayElement) => Object.assign({}, _arrayElement));
      console.log('this.fav_list2',this.fav_list2);
      
     
      this.all_list.forEach((categroy,i) => {
        categroy.category_tab.forEach((element,j) => {
          element.is_favourite = 0;
          this.fav_list.forEach((fav_cat,k) => {
            fav_cat.category_tab.forEach((fav,t) => {
              if(fav.sub_category_id == element.sub_category_id) {
                element.is_favourite = 1;
                fav.before_order = t+1;
              }
            });
          });
        });
      });

      this.fav_list.forEach(element => {
        if(element._id == this.edit_category_id) {
          this.edit_fav_list = element.category_tab
        }
        
      });

      console.log('this.all_list2',this.all_list);
      

    });

  }
  changeFavourite(e,item) {
     /** spinner starts on init */
     this.spinner.show();
    const data = {
      slug: item.slug,
      is_favourite: item.is_favourite,
      sub_category_id: item.sub_category_id,
      tab_id: item.category_tab_id,
      catlogue:CatlougeTypeConstants.catlogue
    }
    if(e.target.checked) {
      data.is_favourite = 1;
    }else {
      data.is_favourite = 0;
    }
    let urlEncodedBodyData = this.userService.convertoJSONToUrlEncoded(data);
    this.assetsService.addRemoveFavourite(urlEncodedBodyData).subscribe(data => {
        this.getAllGuruji();
    
    });
  }

  reorder(event: CdkDragDrop<string[]>) {

    let droped_element:any =  event.previousContainer.data[event.previousIndex];
    let dragging_element:any =  event.previousContainer.data[event.currentIndex];
     if (event.previousContainer === event.container) {
       if(droped_element.sub_category_id != dragging_element.sub_category_id) {
           /** spinner starts on init */
           this.spinner.show();
       this.edit_fav_list.forEach((element,i) => {
         if(element.sub_category_id == droped_element.sub_category_id) {
           console.log('dropped',element);
          
           this.edit_fav_list[i].after_order = event.currentIndex+1;
           const data = {
             favourite_id: element.favorite_id,
             before_order: element.before_order,
             after_order: element.after_order,
           }
           const params = {
             call: 'reorder',
             catlogue:CatlougeTypeConstants.catlogue
           }
            this.setSingleRordering(data,params);
         }
         if(element.sub_category_id == dragging_element.sub_category_id) {
           console.log('draggging',element);
           this.edit_fav_list[i].after_order = event.previousIndex+1;
         }
       });
   
     }
 
       moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
     } else {
 
     
 
       transferArrayItem(
         event.previousContainer.data,
         event.container.data,
         event.previousIndex,
         event.currentIndex,
       );
     }
   }
   setSingleRordering(data,params) {
     console.log('reordering setting ..');
     let urlEncodedBodyData = this.userService.convertoJSONToUrlEncoded(data);
     let urlEncodedParamsData = this.userService.convertoJSONToUrlEncoded(params);
     this.assetsService.reorderFavourite(urlEncodedBodyData,urlEncodedParamsData).subscribe(data => {
    
     this.getAllGuruji();
 
     });
   }
   removeFavourite(item) {
       /** spinner starts on init */
      if(this.edit_fav_list.length == 1) {
        this.modalService.dismissAll()
      }
       this.spinner.show();
       const data = {
         slug: item.slug,
         is_favourite: 0,
         sub_category_id: item.sub_category_id,
         tab_id: item.category_tab_id,
         catlogue:CatlougeTypeConstants.catlogue
       }
       let urlEncodedBodyData = this.userService.convertoJSONToUrlEncoded(data);
       this.assetsService.addRemoveFavourite(urlEncodedBodyData).subscribe(data => {
           this.getAllGuruji();
       });
   }
 openModal(content,cat_id?) {
  // this.modalService.open(content);
  this.edit_category_id = null;
  if(cat_id) {
    this.fav_list.forEach(element => {
      if(element._id == cat_id) {
        this.edit_category_id = cat_id;
        this.edit_fav_list = element.category_tab
      }
      
    });
  }
  console.log('this.edit_fav_list',this.edit_fav_list);
  
  this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: true, windowClass:'' }).result.then((result) => {
  }, (reason) => {
  });
 }

 closeModal() {
    this.modalService.dismissAll();
 }
//   changeFavourite(e,data) {
//     this.added_guruji =   this.added_guruji.filter(ele => {
//           if(ele._id != data._id) {
//             return ele;
//           }
//     })
//     this.added_guruji.push(data);
//     if(e.target.checked) {
//       data.is_favourite = 1;
//       // this.added_guruji.push(data);
//     }else {
//       data.is_favourite = 0;
  
//     }
//   }

// async  submitFavourite() {
//   let last_index= false;
//   let i = 1;
//    for (const iterator of this.added_guruji) {
//     const data = {
//       slug: iterator.slug,
//       is_favourite: iterator.is_favourite,
//       sub_category_id: iterator._id,
//       tab_id: iterator.tab_id,
//       catlogue:CatlougeTypeConstants.catlogue
//     }
//     last_index = this.added_guruji.length == i ? true: false;
//    await this.addFav(data,last_index);
//    await this.sleep(300);
//     i++;
//    }
//   }

//   sleep(ms) {
//     return new Promise(resolve => setTimeout(resolve, ms));
//   }

//   addFav(data,last_index) {
//     let urlEncodedBodyData = this.userService.convertoJSONToUrlEncoded(data);
//     this.assetsService.addRemoveFavourite(urlEncodedBodyData).subscribe(data => {
//       if(last_index) {
//         this.added_guruji = [];
//         this.getAllGuruji();
//       }
      

//     });
//   }

  
  // saveEdit() {
  //   let reoder_list = this.fav_list.filter(element => {
  //     if(element.after_order && element.after_order != element.before_order) {
  //       return element;
  //     }
  //   });
  //   if(reoder_list.length){
  //     this.saveReordering(reoder_list);
  //   }else if(this.removed_guruji.length) {
  //        this.saveRemomveFavourite();
  //   }
  // }

  // removeFavourite(item) {
  //   this.removed_guruji.push(item);
  //   this.fav_list = this.fav_list.filter(e =>{
  //     if (e.sub_category_id != item.sub_category_id) {
  //       return e;
  //     }
  //   })

  // }
  // saveRemomveFavourite() {
  //   this.removed_guruji.forEach((element,i) => {
  //     const data = {
  //       slug: element.slug,
  //       is_favourite: 0,
  //       sub_category_id: element.sub_category_id,
  //       tab_id: element.tab_id,
  //       catlogue:CatlougeTypeConstants.catlogue
  //     }
  //     let urlEncodedBodyData = this.userService.convertoJSONToUrlEncoded(data);
  //     this.assetsService.addRemoveFavourite(urlEncodedBodyData).subscribe(data => {
  //       if(this.removed_guruji.length-1 == i) {
  //         this.removed_guruji = [];
  //         this.getAllGuruji();
  //       }
  //     });
  //   });
  // }
  // async saveReordering(reoder_list) {
  //   let i = 1;
  //   let last_index = false;
  //   for (const element of reoder_list) {
  //       const data = {
  //         favourite_id: element.favourite_id,
  //         before_order: element.before_order,
  //         after_order: element.after_order,
  //       }
  //       const params = {
  //         call: 'reorder',
  //         catlogue:CatlougeTypeConstants.catlogue
  //       }
        
  //       last_index = reoder_list.length == i ? true :false
  //      await this.setRordering(data,params,last_index);
  //      await this.sleep(300);
  //     i++;
  //   }
   
  // }
  // setRordering(data,params,last_index) {
  //   let urlEncodedBodyData = this.userService.convertoJSONToUrlEncoded(data);
  //   let urlEncodedParamsData = this.userService.convertoJSONToUrlEncoded(params);
  //   this.assetsService.reorderFavourite(urlEncodedBodyData,urlEncodedParamsData).subscribe(data => {
  //    if(last_index) {
  //     console.log('last index');
  //     if(this.removed_guruji.length) {
  //       this.saveRemomveFavourite();
  //     }else {
  //       this.getAllGuruji();
  //     }
      
  //    }

  //   });
  // }

 



}
